import { InputFieldProps } from "./types";

export const RangeInput: React.FC<InputFieldProps> = ({ inputField, inputValue, onUpdate }) => {
	if (inputField.type !== "range") {
		return <>non-range input field types is not currently supported</>;
	}

	const rangeValue = (inputValue ?? {}) as { start?: number; end?: number };

	const handleChange = (key: "start" | "end", value: string) => {
		const next = { ...rangeValue, [key]: value === "" ? undefined : Number(value) };
		const isEmpty = next.start === undefined && next.end === undefined;
		onUpdate?.(isEmpty ? undefined : next);
	};

	return (
		<div className="flex flex-row items-center gap-2">
			<input
				onChange={(e) => handleChange("start", e.target.value)}
				type="number"
				value={rangeValue.start ?? ""}
				placeholder="start (inclusive)"
				className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
			/>
			<span className="text-gray-500">to</span>
			<input
				onChange={(e) => handleChange("end", e.target.value)}
				type="number"
				value={rangeValue.end ?? ""}
				placeholder="end (inclusive)"
				className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
			/>
		</div>
	);
};
